import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Capture auth params from URL (hash + query) AND sessionStorage.
// The inline script in index.html stores params in sessionStorage
// BEFORE any JS bundles load, so they survive URL-stripping by the Supabase client.
function captureAuthParams() {
  // Primary: check sessionStorage (set by index.html inline script)
  try {
    const storedError = sessionStorage.getItem('__recovery_error');
    if (storedError) {
      sessionStorage.removeItem('__recovery_error');
      const parsed = JSON.parse(storedError);
      return {
        type: 'error',
        error: parsed.error,
        errorCode: parsed.errorCode,
        errorDescription: parsed.errorDescription,
      };
    }
    const storedRecovery = sessionStorage.getItem('__recovery_mode');
    if (storedRecovery) {
      sessionStorage.removeItem('__recovery_mode');
      return { type: 'recovery' };
    }
  } catch (e) { /* sessionStorage not available */ }

  // Fallback: check current URL params (may already be stripped by Supabase)
  const hashStr = window.location.hash.substring(1);
  const searchStr = window.location.search;
  const hashParams = new URLSearchParams(hashStr);
  const queryParams = new URLSearchParams(searchStr);

  const error = hashParams.get('error') || queryParams.get('error');
  if (error) {
    return {
      type: 'error',
      error,
      errorCode: hashParams.get('error_code') || queryParams.get('error_code'),
      errorDescription: hashParams.get('error_description') || queryParams.get('error_description'),
    };
  }

  const authType = hashParams.get('type');
  if (authType === 'recovery') {
    return { type: 'recovery' };
  }

  return null;
}

export const capturedAuthParams = captureAuthParams();

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_URL = `${BACKEND_URL}/api`;
